export const QUIZZES_KEY = 'quizzes';
export const QUIZ_KEY = 'quiz';
